// extracted by mini-css-extract-plugin
export default {"loadingBig":"loading_loadingBig__mhu-c","heartbeat":"loading_heartbeat__IBwaT"};